import './Header.scss';

import { CoffeeOutlined, MenuOutlined, PhoneOutlined, QuestionOutlined, TagsOutlined } from '@ant-design/icons';
import { Col, Divider, Drawer, Menu, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import SubMenu from 'antd/lib/menu/SubMenu';
import { images } from 'src/assets/img';
import { useHistory } from 'react-router-dom';

function Header() {
	const [current, setCurrent] = useState('mail');
	const [visible, setVisible] = useState(false);
	const [isEdenRedHovered, setEdenredHovered] = useState(false);
	const [isAboutHovered, setAboutHovered] = useState(false);
	const [offset, setOffset] = useState(0);
	const history = useHistory();
	useEffect(() => {
		window.onscroll = () => {
			setOffset(window.pageYOffset);
		};
	}, []);

	const handleClick = () => {
		setVisible(!visible);
	};
	function useOutsideAlerter(ref) {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setEdenredHovered(false);
					setAboutHovered(false);
				}
			}
			// Bind the event listener
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	}
	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);
	return (
		<>
			<div className="header-outer-main">
				<Row className={offset >= 200 ? 'atm-loc-header-outer-scrolled' : 'atm-loc-header-outer'}>
					<Col xs={2} sm={4} md={6} lg={8} xl={5} className={offset >= 200 ? 'atm-loc-logo-scrolled' : 'atm-loc-logo'}>
						<img src={images.edenredlog} alt="edenredlog" className="edenredlogo" />
					</Col>
					<Col xs={22} sm={20} md={18} lg={16} xl={19} className={offset >= 200 ? 'links-scrolled' : 'links'} ref={wrapperRef}>
						<div className="link-only-container">
							<div className="DropdownContainer">
								<div
									className="links-header"
									onMouseEnter={() => {
										setAboutHovered(false);

										setEdenredHovered(true);
									}}>
									Products
								</div>
								{isEdenRedHovered && (
									<div className="dropdownHeader" onMouseLeave={() => setEdenredHovered(false)}>
										<a href="https://edenred.ae/edenred-payroll/" className="links-header links-header-dropdown">
											Edenred Payroll
										</a>
										<a href="https://edenred.ae/c3pay/" className="links-header links-header-dropdown">
											c3Pay
										</a>
									</div>
								)}
							</div>
							<div className="DropdownContainer">
								<div
									className="links-header"
									onMouseEnter={() => {
										setAboutHovered(true);
										setEdenredHovered(false);
									}}>
									About
								</div>
								{isAboutHovered && (
									<div className="dropdownHeader dropDownheader2" onMouseLeave={() => setAboutHovered(false)}>
										<a
											href="https://www.edenred.com/en/discover-group/who-are-we"
											target="_blank"
											className="links-header links-header-dropdown">
											Who are we
										</a>
										<a href="https://edenred.ae/our-story/" className="links-header links-header-dropdown">
											Our Story
										</a>
										<a href="https://edenred.ae/our-mission/" className="links-header links-header-dropdown">
											Our Mission
										</a>
										<a
											href="https://www.edenred.com/en/candidates/work-edenred"
											target="_blank"
											className="links-header links-header-dropdown">
											Careers
										</a>
									</div>
								)}
							</div>
							<a href="https://edenred.ae/faq/" className="links-header">
								FAQs
							</a>
							<a href="https://edenred.ae/news/" className="links-header">
								News
							</a>
							<a href="https://edenred.ae/contact-us/" className="links-header">
								Contact Us
							</a>
						</div>
						<div className="btn-header">
							<div className="btn">
								<div>
									<img className="user-icon" src={images.usericon} alt="" />
								</div>
								<div>
									<button onClick={() => window.open('https://payroll.edenred.ae/', '_blank')} className="btn-payroll-head">
										PAYROLL LOGIN
									</button>
								</div>
							</div>

							<div>
								<button className="btn1" onClick={() => window.open('https://edenred.ae/request-demo/', '_self')}>
									REQUEST DEMO
								</button>
							</div>
						</div>
					</Col>
				</Row>

				<Row className="hamburger-mob">
					<div className="parent-logo-con">
						<div className="atm-loc-logo">
							<img src={images.edenredlog} alt="edenredlog" className="edenredlogo" />
						</div>
						<div onClick={handleClick} className="ham-sub">
							<img src={images.ham} alt="" />
						</div>
					</div>
					<Drawer placement="left" closable={false} onClose={handleClick} visible={visible} key="left" style={{ padding: 0 }}>
						<div className="parent-con-icon">
							<div className="con-icon">
								<TagsOutlined style={{ color: '#d52b1e' }} />
							</div>
							<div className="mobile-header-text">Products</div>
						</div>
						<Divider style={{ margin: 0 }} />
						<div className="parent-con-icon">
							<div className="con-icon">
								<QuestionOutlined style={{ color: '#d52b1e' }} />
							</div>
							<div className="mobile-header-text">About</div>
						</div>
						<Divider style={{ margin: 0 }} />
						<div className="parent-con-icon">
							<div className="con-icon">
								<QuestionOutlined style={{ color: '#d52b1e' }} />
							</div>
							<div className="mobile-header-text">FAQs</div>
						</div>
						<Divider style={{ margin: 0 }} />

						<div className="parent-con-icon">
							<div className="con-icon">
								<CoffeeOutlined style={{ color: '#d52b1e' }} />
							</div>
							<div className="mobile-header-text">News</div>
						</div>
						<Divider style={{ margin: 0 }} />

						<div className="parent-con-icon">
							<div className="con-icon">
								<PhoneOutlined style={{ color: '#d52b1e' }} />
							</div>
							<div className="mobile-header-text">Contact Us</div>
						</div>
						<Divider style={{ margin: 0 }} />

						<div className="parent-con-icon centering-con">
							<button className="btn mobile-header-btn1">
								<img className="user-icon" src={images.usericon} alt="" /> PAYROLL LOGIN
							</button>
						</div>
						<div className="parent-con-icon centering-con">
							<button className="btn1 mobile-header-btn1">REQUEST DEMO</button>
						</div>
					</Drawer>
				</Row>

				<Row className="atm-loc-outer">
					<Col xs={24} sm={24} md={24} lg={10} xl={10} className="atm-loc-text">
						<h1>ATM Locations</h1>
					</Col>
					<Col xs={12} sm={12} md={12} lg={14} xl={14} className="atm-loc-img">
						<img src={images.atmlocation} alt="edenredlog" className="atm-location" />
					</Col>
				</Row>
			</div>
		</>
	);
}

export default Header;
